<div class="container">
  <app-drawer-workorder-title
    title="{{ 'workorder.optimize.title' | translate }}"
    [externalId]="workOrder.externalId"
    [clientName]="workOrder.clientName"
  ></app-drawer-workorder-title>

  <div class="optimize-content">
    <p>
      {{ "workorder.optimize.description" | translate }}
    </p>
    <p>{{ "workorder.optimize.confirm-question" | translate }}</p>
  </div>

  <app-drawer-workorder-actions
    confirmButtonName="{{ 'workorder.optimize.save' | translate }}"
    (clickConfirmButtonEvent)="confirm()"
    (clickCancelButtonEvent)="close()"
  ></app-drawer-workorder-actions>
</div>
